export default __webpack_public_path__ + "static/685-0d3eb369e51e813717ec7a0efd05d726.jpg";